import { useEffect, useState } from 'react'
import { encodeToBase64, isNil } from '../../utils/helpers'
import dayjs from 'dayjs'

export interface UseCartHookResp {
  isdn?: string
  token?: string
  isLoggedIn?: boolean
  login?: () => void
  logout?: () => void
  setUserPhone: (isdn: string) => void
  handleWebview: (isdn: string) => void
}

export const useAuthHook = (): UseCartHookResp => {
  const [token, setToken] = useState<string>()
  const [isdn, setIsdn] = useState<string | undefined>()

  const login = (): void => {
    setToken('token')
  }

  const handleWebview = (val: string): void => {
    if (isdn !== val) {
      setIsdn(val)
    }
  }

  const logout = (): void => {
    setToken(undefined)
    setIsdn(undefined)
  }

  useEffect(() => {
    if (isdn !== undefined) {
      localStorage.setItem('mc_webview_token', window.btoa(isdn))
    }
  }, [isdn])

  const setUserPhone = (phone: string): void => {
    localStorage.setItem('mc_user_phone', JSON.stringify({ phone: encodeToBase64(phone), date: new Date() }))
  }

  const localToken = typeof window !== 'undefined' ? localStorage.getItem('mc_webview_token') : null
  const localIsdn: string | undefined = localToken !== null ? window.atob(localToken) : undefined

  const getWebUserPhone = (): string | undefined => {
    const localString = typeof window !== 'undefined' ? localStorage.getItem('mc_user_phone') : null

    if (localString !== null) {
      const localObj: { phone: string, date: Date } = JSON.parse(localString)
      const { phone, date } = localObj
      if (dayjs().add(-2, 'hours').isBefore(date)) {
        return window.atob(phone)
      }
    }

    return undefined
  }

  return {
    isdn: getWebUserPhone() ?? localIsdn,
    token,
    isLoggedIn: !isNil(getWebUserPhone() ?? localIsdn),
    handleWebview,
    setUserPhone,
    login,
    logout
  }
}

export default useAuthHook
